import { useCallback, useRef } from 'react';

// FootprintDropdown keeps its open state private and forwards no ARIA props, so the state it
// reports through onToggle is written onto its button. Delete once the library sets aria-expanded (A-03).
export function useFootprintExpanded(onToggle?: (expanded: boolean) => void) {
  const trigger = useRef<HTMLButtonElement | null>(null);
  const ref = useCallback((container: HTMLElement | null) => {
    trigger.current = container?.querySelector('button') ?? null;
    trigger.current?.setAttribute('aria-expanded', 'false');
  }, []);
  return {
    ref,
    onToggle: (expanded: boolean) => {
      trigger.current?.setAttribute('aria-expanded', String(expanded));
      onToggle?.(expanded);
    },
  };
}
